export enum RequestStatus {
    draft = "DRAFT",
    mixed = "MIXED",
    rejected = "REJECTED",
    submitted = "SUBMITTED",
    toModify = "TO_MODIFY",
    toReview = "TO_REVIEW",
    validated = "VALIDATED",
    assessed = "ASSESSED",
    canceled = "CANCELED",
}
